module.exports = __webpack_public_path__ + "02.png?816f908207202a04724bfe1aec2d8a34";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/02.png
// module id = 117
// module chunks = 3